var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bestline-box"},_vm._l((_vm.bestline),function(pos,index){return _c('div',{key:index},[_c('div',{staticClass:"move",on:{"mouseover":function () {
          _vm.mouseoverPV(index)
        },"mouseleave":_vm.mouseleavePV,"dblclick":function () {
          _vm.dblclickPV(index)
        }}},[_vm._v("\n      "+_vm._s(String.fromCharCode('A'.charCodeAt(0) + pos[0]) + (pos[1] + 1))+"\n    ")])])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }